import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AnnouncerModeService } from '../services/announcer-mode.service';

@Injectable({
  providedIn: 'root',
})
export class AnnouncerModeGuard {
  private _router: Router = inject(Router);
  private _announcerMode: AnnouncerModeService = inject(AnnouncerModeService);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (!this._announcerMode.isActive()) {
      return true;
    }

    const currentEventId = this._announcerMode.eventId();
    const targetUrl = state.url;

    // Allow logout
    if (targetUrl === '/login') {
      return true;
    }

    // Allow navigation within the current event
    if (
      currentEventId &&
      targetUrl.includes(`/events/${currentEventId}`) &&
      !targetUrl.includes(`/events/${currentEventId}/edit`) &&
      !targetUrl.includes(`/events/${currentEventId}/shoutouts/kiosk`)
    ) {
      return true;
    }

    // Block all other navigation
    console.warn(
      'Navigation blocked: In announcer mode. Please logout to exit.',
    );
    return this._router.parseUrl(`/events/${currentEventId}`);
  }
}
